/**
 * Converts a UTC ISO string from the backend into a YYYY-MM-DD date string
 * expressed in IST (Asia/Kolkata, UTC+5:30). Returns "" for null/undefined.
 *
 * "en-CA" locale produces YYYY-MM-DD which is what <input type="date"> expects.
 */
export const utcIsoToIstDate = (iso?: string | null): string => {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
};
